import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormFields } from '~/components/FormFields'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

interface Props extends FieldComponentProps {
  options?: { value: any; text: string; flag?: string }[]
}

const SelectField: React.FC<Props> = ({ field, name, options = [], disabled }) => {
  const { control } = useFormContext()
  const required = !disabled && Boolean(field.fieldRequired)

  return (
    <FormFields.Select
      name={`${name}.value`}
      control={control}
      disabled={disabled}
      label={<LabelWithInfo label={field.label} info={field.info} required={required} />}
      placeholder={field.placeholder}
      options={options}
      search={!disabled}
      selectOnBlur={false}
      rules={required ? { required: true } : {}}
    />
  )
}

export default SelectField
